import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import store from '@/app/store/store'
import { PositionPresenter } from '@/app/ui/presenters/PositionPresenter'
import { Position, PositionDnet } from '@/domain/entities/Position'
import {
  PositionApiRequest,
  UpdatePositionRequest,
  DeletePositionRequest,
} from '@/data/payload/api/PositionRequest'
import Vue from 'vue'

export interface PositionState {
  PositionData: Position
  PositionDataDnet: PositionDnet
  isLoading: boolean
  fields: any
}

@Module({ namespaced: true, dynamic: true, store, name: 'position' })
class Positions extends VuexModule implements PositionState {
  public PositionData = new Position(true, '')
  public PositionDataDnet = new PositionDnet(true, '')
  public isLoading = true
  public fields = [
    { key: 'no', sortable: false },
    { key: 'description', sortable: false },
    { key: 'code', sortable: false },
    { key: 'storage', sortable: false },
    { key: 'actions', sortable: false },
  ]

  @Action
  public async getPosition() {
    this.setLoading(true)
    const presenter = await container.resolve(PositionPresenter)
    presenter
      .loadPosition()
      .then((res: Position) => {
        this.getPositionDnet()
        this.setpositionData(res)
        //  console.log('data', res)
      })
      .catch((error) => {
        this.setLoading(false)
        console.error('error', error)
      })
  }

  @Action
  public async getPositionDnet() {
    this.setLoading(true)
    const presenter = await container.resolve(PositionPresenter)
    presenter
      .loadPositionDnet()
      .then((res: PositionDnet) => {
        this.setLoading(false)
        this.setpositionDataDnet(res)
        //  console.log('data dnet', res)
      })
      .catch((error) => {
        this.setLoading(false)
        console.error('error', error)
      })
  }

  @Action
  public async postPosition(params: { code: string; description: string }) {
    this.setLoading(true)
    const presenter = await container.resolve(PositionPresenter)
    presenter
      .postPosition(new PositionApiRequest(params.code, params.description))
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Position',
          message: res.message,
          type: 'success',
          duration: 5000,
        })
        this.getPosition()
      })
      .catch((error) => {
        this.setLoading(false)
        Vue.prototype.$notify({
          title: 'Position',
          message: 'Failed',
          type: 'error',
          duration: 5000,
        })
      })
  }

  @Action
  public async updatePosition(params: {
    id: number
    code: string
    description: string
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(PositionPresenter)
    presenter
      .updatePosition(
        new UpdatePositionRequest(params.code, params.description),
        params.id
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Position',
          message: res.message,
          type: 'success',
          duration: 5000,
        })
        this.getPosition()
      })
      .catch((error) => {
        this.setLoading(false)
        Vue.prototype.$notify({
          title: 'Position',
          message: 'Failed',
          type: 'error',
          duration: 5000,
        })
      })
  }

  @Action
  public async deletePosition(params: { ids: any }) {
    this.setLoading(true)
    const presenter = await container.resolve(PositionPresenter)
    presenter
      .deletePosition(new DeletePositionRequest(params.ids))
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Position',
          message: res.message,
          type: 'success',
          duration: 5000,
        })
        this.getPosition()
      })
      .catch((error) => {
        this.setLoading(false)
        Vue.prototype.$notify({
          title: 'Position',
          message: 'Failed',
          type: 'error',
          duration: 5000,
        })
      })
  }

  @Mutation
  private setpositionData(position: Position) {
    this.PositionData = position
  }

  @Mutation
  private setpositionDataDnet(position: PositionDnet) {
    this.PositionDataDnet = position
  }

  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }
}

export const PositionDataModule = getModule(Positions)
